
import {Component,Mixins} from 'vue-property-decorator'
import EventBus from './../../eventBus'
import UserProVisioning from "@/mixins/userProvisioning"

@Component
export default class FundingsOverview extends Mixins(UserProVisioning){
    // DATA
    activeItem: any = null
    search: string = ''
    error: string = ''
    activeScreen: string = 'loading'
    loadingMessage: string = 'Loading Funding Mechanisms'
    loadingTitle: string = 'Loading...'
    deletePromptProperty: boolean = false
    successMessage: string = ''
    additionalSuccessMessage = ''
    selectedRows: {name: string; id: string}[] = []
    selectAll: boolean = false

    // COMPUTED PROPERTIES
    get getFundings () {
        return this.$store.getters['fundingsModule/getFundings'].sort((a: any, b: any) => {
            const itemA = (a.name || '').toString().toLowerCase().trim();
            const itemB = (b.name || '').toString().toLowerCase().trim();
            return itemA.localeCompare(itemB, undefined, {
                sensitivity: 'base',
                numeric: true
            });
        });
    }

    get fields(){
        if(this.canWriteBudgetSettings)
        {
           return [
               {key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" }},
               { key: 'serial', label: 'S/N', sortable: false },
               {key:'name',label:"Funding Tranche", sortable:true},
               {key: 'code', label:"Short Code", sortable: 'true'},'SampleDisplay',
               {key: 'button', label: "Actions"} 
            ]
        }
    return [
        {key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" }},
        { key: 'serial', label: 'S/N', sortable: false },
        {key:'name',label:"Funding Tranche", sortable:true},
        {key: 'code', label:"Short Code", sortable: 'true'},'SampleDisplay']
    }

    get allProjects() {
        return this.$store.getters['projectModule/getAllProjects']
    }

    disableDelete(item:any){
        let foundProjectClass = this.allProjects.find((project:any) => {
            if (project.funding && project.funding !== null) {
                return project.funding.name === item.name
            }
            return null;
        })
        if (foundProjectClass && foundProjectClass !== '' && foundProjectClass != null) {
            return true
        }else {
            return false
        }
    }

    // VUEX METHODS AND MUTATIONS
    deleteFunding (funding: any) {
        return this.$store.commit('fundingsModule/deleteFunding', funding)
    }
    fetchFundings () {
        return this.$store.dispatch('fundingsModule/fetchFundings')
    }



    // METHODS
    updateFunding(item: any){
        this.activeItem = item;
        this.$router.push({path:'/manage-funding/', query:{id:item.id}})
    }

    promptDelete(item: any){
        this.activeItem = item;
        this.deletePromptProperty = true
    }

    searchValue(e: any) {
        this.search = e
    }

    toggleSelectAll() {
        if (!this.selectAll) {
            this.selectedRows = this.getFundings.map((funding: any) => ({id: funding.id, name: funding.name}))
        } else {
            this.selectedRows = []
        }
    }

    getFundingMechanismsToDelete () {
        const names = this.selectedRows.map(row => row.name);

        let formattedNames = '';
        if (names.length <= 3) {
            const lastTwoNames = names.splice(-2);
            if (this.selectedRows.length === 2) {
                return formattedNames = `${names.join(', ')} ${lastTwoNames.join(' and ')}`;
            }
            return formattedNames = `${names.join(', ')}, ${lastTwoNames.join(' and ')}`;
        }
        else {
            const firstTwoNames = names.slice(0, 2);
            const remainingCount = names.length - 2;
            return `${firstTwoNames.join(', ')} and ${remainingCount} other${remainingCount > 1 ? 's' : ''} funding mechanism${remainingCount > 1 ? 's' : ''}`;
        }
    }

    doDelete(){
        const isMultipleDelete = this.selectedRows.length;
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen)
        this.loadingMessage = `Please wait while we delete ${isMultipleDelete ? 'these funding mechanisms' : 'this funding mechanism'}`
        this.loadingTitle = 'Deleting...'

        const payload = isMultipleDelete ? this.selectedRows.map(row => row.id) : [this.activeItem.id]
        this.$store.dispatch('fundingsModule/deleteFundingAciton', payload)
        .then((res: any) =>{
            this.activeScreen = 'successNoBack'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.additionalSuccessMessage = 'This funding mechanism will no longer be available'
            this.successMessage = this.activeItem.name + ' Deleted Successfully'
            this.deletePromptProperty = false
        })
        .catch((error: any) => {
            this.activeScreen = 'error'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.error = error.message
            this.deletePromptProperty = false
        })
    }


    // CREATED
    mounted() {
        this.activeScreen = 'loading';        
        this.$store.dispatch("projectModule/getAllProjects")
        EventBus.$emit('activeScreen', this.activeScreen)
        if (this.getFundings.length <= 0) {
            this.fetchFundings().then(() => {
                this.activeScreen = 'main';
                EventBus.$emit('activeScreen', this.activeScreen)
            })
        } else {
            this.activeScreen = 'main';
            EventBus.$emit('activeScreen', this.activeScreen)
        }
    }
}
